export default "__VITE_ASSET__fa7a9d12__"